const rxgFormat = (rxg: string, args: string[]) => {
    args.forEach((arg, i) => {
        rxg = rxg.replace(new RegExp(`\\{${i}\\}`, 'g'), arg);
    });
    return rxg;
};

export { rxgFormat }
